import React from 'react';

interface FilterChipProps {
  /** Chip label */
  label: string;
  /** Whether the chip is active/selected */
  isActive: boolean;
  /** Count badge (optional) */
  count?: number;
  /** Icon (optional) */
  icon?: React.ReactNode;
  /** Click handler */
  onClick: () => void;
  /** Disabled state */
  disabled?: boolean;
}

/**
 * FilterChip Component
 *
 * A small pill-style button for filter toggles.
 * Supports active state, count badge, and icon.
 */
export const FilterChip: React.FC<FilterChipProps> = ({
  label,
  isActive,
  count,
  icon,
  onClick,
  disabled = false,
}) => {
  return (
    <button
      className={`filter-chip ${isActive ? 'active' : ''}`}
      onClick={onClick}
      disabled={disabled}
      type="button"
      role="tab"
      aria-selected={isActive}
      aria-label={count !== undefined ? `${label} (${count})` : label}
    >
      {icon && <span className="filter-chip-icon" aria-hidden="true">{icon}</span>}
      <span className="filter-chip-label">{label}</span>
      {count !== undefined && count > 0 && (
        <span className="filter-chip-count" aria-hidden="true">{count}</span>
      )}
    </button>
  );
};

export default FilterChip;
